// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__dC-fO","reset-button":"ForgotPassword_reset-button__bO6XX"};